import { configService } from "../index";
import Reservation from "../../models/reservation";
import { BaseRequests } from "./BaseRequests";
import { BaseRequestsInterface } from "./BaseRequests";

export default {
  ...BaseRequests(
    () => configService.profileReservation,
    "reservation",
    () => new Reservation()
  )
} as BaseRequestsInterface;
